import Cookies from 'js-cookie';
import utils from '@/_modules/utils';

class _alertModal {
  //constructor() {}

  once() {
    this.hasAgree = false;
    if (!this.checkCookie()) {
      this.init();
    } else {
      this.hasAgree = true;
      gTOCO.rootHTML.classList.add('has-agree');
    }
  }

  init() {
    this.el = document.getElementById('c-alert');
    if (this.el) {
      this.btn = document.getElementById('c-alertModal__btn');
      this.btn.addEventListener('click', this.agree.bind(this));
      gTOCO.rootHTML.classList.add('is-show-active');
    }
  }

  start() {
    if (!this.hasAgree) gTOCO.rootHTML.classList.add('is-show-alert');
  }

  agree() {
    // クッキー同意する
    //alert('同意する');
    Cookies.set('is-agree', 1, { expires: 1 });
    gTOCO.rootHTML.classList.remove('is-show-active');
    gTOCO.rootHTML.classList.remove('is-show-alert');
  }

  checkCookie() {
    // クッキー同意済みか確認する
    if (parseInt(Cookies.get('is-agree'), 10) === 1) {
      // 同意済み
      return true;
    }
    return false;
  }
}

const alertModal = new _alertModal();

export default alertModal;